import React from 'react';
import { HeaderText, BoldText } from './styles';

export default class HeaderInfo extends React.Component {

  noAdsText = 'Nem találtunk hirdetéseket.';

  render = () => {
    const adsFound = this.props.adNum > 0;
    let content = <HeaderText><p>{this.noAdsText}</p></HeaderText>;
    if (adsFound) {
      content =
      <HeaderText>
        <BoldText>Veszélyben a jutalékod</BoldText>
        <p>
          A tulajdonosok általában nem szólnak, ha leviszik az
          ingatlan árát egy másik tanácsadó számára. Ilyenkor a
          vevők jó eséllyel rátalálnak az olcsóbb hirdetésre és
          nem tőled veszik meg az ingatlant. Ezért ezt a listát
          mindig tartsd üresen.
        </p>
      </HeaderText>
    }
    return content;
  }

}



// WEBPACK FOOTER //
// ./src/components/HeaderInfo/index.js